"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MojosDescriptor__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
const ethers_1 = require("ethers");
const _abi = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "string",
                name: "baseURI",
                type: "string",
            },
        ],
        name: "BaseURIUpdated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "bool",
                name: "enabled",
                type: "bool",
            },
        ],
        name: "DataURIToggled",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "previousOwner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "OwnershipTransferred",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [],
        name: "PartsLocked",
        type: "event",
    },
    {
        inputs: [
            {
                internalType: "string",
                name: "_background",
                type: "string",
            },
        ],
        name: "addBackground",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "_body",
                type: "bytes",
            },
        ],
        name: "addBody",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "_bodyAccessory",
                type: "bytes",
            },
        ],
        name: "addBodyAccessory",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint8",
                name: "_paletteIndex",
                type: "uint8",
            },
            {
                internalType: "string",
                name: "_color",
                type: "string",
            },
        ],
        name: "addColorToPalette",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "_face",
                type: "bytes",
            },
        ],
        name: "addFace",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "_headAccessory",
                type: "bytes",
            },
        ],
        name: "addHeadAccessory",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "string[]",
                name: "_backgrounds",
                type: "string[]",
            },
        ],
        name: "addManyBackgrounds",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes[]",
                name: "_bodies",
                type: "bytes[]",
            },
        ],
        name: "addManyBodies",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes[]",
                name: "_bodyAccessories",
                type: "bytes[]",
            },
        ],
        name: "addManyBodyAccessories",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint8",
                name: "paletteIndex",
                type: "uint8",
            },
            {
                internalType: "string[]",
                name: "newColors",
                type: "string[]",
            },
        ],
        name: "addManyColorsToPalette",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes[]",
                name: "_faces",
                type: "bytes[]",
            },
        ],
        name: "addManyFaces",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes[]",
                name: "_headAccessories",
                type: "bytes[]",
            },
        ],
        name: "addManyHeadAccessories",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "arePartsLocked",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "backgroundCount",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "backgrounds",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "baseURI",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "bodies",
        outputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "bodyAccessories",
        outputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "bodyAccessoryCount",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "bodyCount",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
            {
                components: [
                    {
                        internalType: "uint48",
                        name: "background",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "body",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "bodyAccessory",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "face",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "headAccessory",
                        type: "uint48",
                    },
                ],
                internalType: "struct IMojosSeeder.Seed",
                name: "seed",
                type: "tuple",
            },
        ],
        name: "dataURI",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "faceCount",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "faces",
        outputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "uint48",
                        name: "background",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "body",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "bodyAccessory",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "face",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "headAccessory",
                        type: "uint48",
                    },
                ],
                internalType: "struct IMojosSeeder.Seed",
                name: "seed",
                type: "tuple",
            },
        ],
        name: "generateSVGImage",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "string",
                name: "name",
                type: "string",
            },
            {
                internalType: "string",
                name: "description",
                type: "string",
            },
            {
                components: [
                    {
                        internalType: "uint48",
                        name: "background",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "body",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "bodyAccessory",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "face",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "headAccessory",
                        type: "uint48",
                    },
                ],
                internalType: "struct IMojosSeeder.Seed",
                name: "seed",
                type: "tuple",
            },
        ],
        name: "genericDataURI",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "headAccessories",
        outputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "headAccessoryCount",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "isDataURIEnabled",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "lockParts",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "owner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint8",
                name: "",
                type: "uint8",
            },
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "palettes",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "renounceOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "string",
                name: "_baseURI",
                type: "string",
            },
        ],
        name: "setBaseURI",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "toggleDataURIEnabled",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
            {
                components: [
                    {
                        internalType: "uint48",
                        name: "background",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "body",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "bodyAccessory",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "face",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "headAccessory",
                        type: "uint48",
                    },
                ],
                internalType: "struct IMojosSeeder.Seed",
                name: "seed",
                type: "tuple",
            },
        ],
        name: "tokenURI",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "transferOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
];
const _bytecode = "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__$e1d8844a0810dc0e87a665b1f2b5fa7c69$__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__$e1d8844a0810dc0e87a665b1f2b5fa7c69$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";
const isSuperArgs = (xs) => {
    return (typeof xs[0] === "string" ||
        Array.isArray(xs[0]) ||
        "_isInterface" in xs[0]);
};
class MojosDescriptor__factory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            const [linkLibraryAddresses, signer] = args;
            super(_abi, MojosDescriptor__factory.linkBytecode(linkLibraryAddresses), signer);
        }
    }
    static linkBytecode(linkLibraryAddresses) {
        let linkedBytecode = _bytecode;
        linkedBytecode = linkedBytecode.replace(new RegExp("__\\$e1d8844a0810dc0e87a665b1f2b5fa7c69\\$__", "g"), linkLibraryAddresses["contracts/libs/NFTDescriptor.sol:NFTDescriptor"]
            .replace(/^0x/, "")
            .toLowerCase());
        return linkedBytecode;
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.MojosDescriptor__factory = MojosDescriptor__factory;
MojosDescriptor__factory.bytecode = _bytecode;
MojosDescriptor__factory.abi = _abi;
